const config = {
  botName: "Chef Chatty",
  greetUserAgainIfIdleFor: 3600, // Seconds user has been away from the app
    dietOptions: ["Vegetarian", "Vegan", "Gluten-Free", "Keto", "Paleo"],
    foodAllergies: [
        "milk",
        "eggs",
        "fish",
        "shellfish",
        "tree nuts",
        "peanuts",
        "wheat",
        "soy",
        "sesame",
      ],
      fontSize: {
        small: "0.85rem",
        medium: "1.0rem",
        large: "1.25rem"
      },
};

export default config;